module.exports = __webpack_public_path__ + "img/ic_logo_scholastic@2x.8d55bd51.png";